import { render, staticRenderFns } from "./AdminProjects.vue?vue&type=template&id=b4317106&"
import script from "./AdminProjects.vue?vue&type=script&lang=js&"
export * from "./AdminProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports